export default class ApiError extends Error
{
  public errorType: ApiErrorType;

  public constructor(errorType: ApiErrorType, message: string)
  {
    super(message);
    this.errorType = errorType;
  }
}

export enum ApiErrorType
{
  NetworkError = "NetworkError",
  Unauthorised = "Unauthorised",
  BadRequest = "BadRequest",
  NotFound = "NotFound",
  InternalServerError = "InternalServerError",
}